import React, { useState } from 'react';
import AnimatedSection from './AnimatedSection';

const videos = [
  { id: '2rI8mbLbJqU', title: 'Klassische Massage' },
  { id: 'O_G0-IJRXkw', title: 'Relax Massage' },
  { id: 'P_H4EDP9HB8', title: 'Reset-Session' }
];

const VideoCard = ({ video, onClick, index }) => (
  <AnimatedSection delay={index * 100} direction="scale">
    <button
      data-testid={`video-card-${video.id}`}
      onClick={onClick}
      className="group relative aspect-video w-full rounded-2xl overflow-hidden bg-brand-dark shadow-lg hover:shadow-2xl transition-all duration-500"
    >
      <img
        src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
        alt={video.title}
        className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-brand-dark/30 to-transparent" />
      
      {/* Play button */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center group-hover:bg-brand-gold group-hover:scale-110 transition-all duration-500 shadow-2xl">
          <svg className="w-6 h-6 md:w-8 md:h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      </div>
      
      {/* Title */}
      <div className="absolute bottom-4 left-4 right-4">
        <p className="font-work text-white text-sm md:text-base font-medium">
          {video.title}
        </p>
      </div>
    </button>
  </AnimatedSection>
);

const VideoModal = ({ videoId, onClose }) => (
  <div
    data-testid="video-modal"
    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-dark/95 backdrop-blur-md"
    onClick={onClose}
  >
    <div className="relative w-full max-w-5xl aspect-video animate-scale-in" onClick={(e) => e.stopPropagation()}>
      <button
        onClick={onClose}
        className="absolute -top-12 right-0 text-white/70 hover:text-white font-work text-sm flex items-center gap-2 group"
      >
        Schließen 
        <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors">×</span>
      </button>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
        title="Video"
        className="w-full h-full rounded-2xl shadow-2xl"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  </div>
);

const Testimonials = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <section
      id="bewertungen"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-brand-light relative overflow-hidden"
    >
      {/* Background decoration */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-brand-gold/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Videos Section */}
        <div>
          <AnimatedSection className="text-center mb-12">
            <span className="inline-flex items-center gap-2 font-work text-sm text-brand-gold uppercase tracking-widest mb-4">
              <span className="w-8 h-px bg-brand-gold" />
              Bewertungen
              <span className="w-8 h-px bg-brand-gold" />
            </span>
            <h2 className="font-marcellus text-4xl md:text-5xl lg:text-6xl text-brand-dark mb-6">
              Kundenstimmen
            </h2>
            <p className="font-work text-brand-dark/60 max-w-2xl mx-auto text-lg">
              Erleben Sie einen Einblick in meine Behandlungen.
            </p>
          </AnimatedSection>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {videos.map((video, index) => (
              <VideoCard
                key={video.id}
                video={video}
                index={index}
                onClick={() => setActiveVideo(video.id)}
              />
            ))}
          </div>
        </div>
      </div>

      {activeVideo && (
        <VideoModal videoId={activeVideo} onClose={() => setActiveVideo(null)} />
      )}
    </section>
  );
};

export default Testimonials;
